import './WorkspaceListSearch.scss';
import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_TextInput } from '../../../../design/inputs/textInput/S_TextInput';
import { IWorkspaceService } from '../workspaces.service';

export const WorkspaceListSearchContainer = observer((): ReactElement => {
  const workspaceService = useInjection(IWorkspaceService.$);

  const { t } = useTranslator();

  const handleSearchChangeDebounced = _.debounce(
    async () => {
      await workspaceService.getWorkspaceListItemsAsync();
    },
    1000,
    {
      leading: false,
      trailing: true,
    }
  );

  const handleChangeWorkspaceName = (value: string): void => {
    workspaceService.store.workspaceNameSearch = value;
    void handleSearchChangeDebounced();
  };

  const handleChangeOwner = (value: string): void => {
    workspaceService.store.workspaceOwnerSearch = value;
    void handleSearchChangeDebounced();
  };

  return (
    <div className='workspace-list-search'>
      <S_TextInput
        id='workspace-search'
        className='workspace-list-search-control'
        value={workspaceService.store.workspaceNameSearch}
        placeholder={t('workspace_name')}
        onChange={handleChangeWorkspaceName}
      />
      <S_TextInput
        id='owner-search'
        className='workspace-list-search-control'
        value={workspaceService.store.workspaceOwnerSearch}
        placeholder={t('owner_email')}
        onChange={handleChangeOwner}
      />
    </div>
  );
});
